import React from 'react';

export type AppContainerProps = React.HTMLAttributes<HTMLDivElement>;

const AppContainer = React.forwardRef<HTMLDivElement, AppContainerProps>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={['mx-auto w-full max-w-7xl px-4', className].filter(Boolean).join(' ')}
      {...props}
    />
  );
});

AppContainer.displayName = 'AppContainer';

export default AppContainer;
